import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl } from "@/lib/api";

export default function ImageField({ label, value, onChange, accept = "image/*", testid }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Uploaded.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload failed.");
    } finally {
      setBusy(false);
    }
  };

  const isPdf = value?.toLowerCase().endsWith(".pdf");

  return (
    <div data-testid={testid}>
      {label && <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-mute">{label}</p>}
      <div className="flex items-center gap-3">
        {value ? (
          isPdf ? (
            <span className="flex h-14 w-20 items-center justify-center border border-line bg-bone font-mono text-[10px] uppercase text-mute">PDF</span>
          ) : (
            <img src={imgUrl(value)} alt="" className="h-14 w-20 rounded-lg border border-line object-cover" />
          )
        ) : (
          <span className="flex h-14 w-20 items-center justify-center border border-dashed border-line font-mono text-[9px] uppercase text-subtle">Empty</span>
        )}
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL or upload →"
          className="flex-1 rounded-xl border border-line bg-white px-3 py-2.5 text-xs outline-none focus:border-srs"
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="flex items-center gap-2 border border-ink px-3 py-2.5 font-mono text-[10px] uppercase tracking-[0.15em] text-ink transition-colors hover:bg-ink hover:text-white disabled:opacity-50"
        >
          <Upload size={13} /> {busy ? "…" : "Upload"}
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="p-2 text-subtle hover:text-srs" aria-label="Clear">
            <X size={14} />
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
    </div>
  );
}
